class StorageClass {
  /**
   * @param {string} [scope] - the scope
   * @param {string} repository - the storage repository, it can be a wrapper of sessionStorage/localStorage
   */
  constructor(repository, scope) {
    this.scope = scope ? scope + "::" : "";
    this.repository = repository;
  }

  has(key) {
    return this.get(key) !== null;
  }

  get(key) {
    return this.repository.get(this.scope + key);
  }

  set(key, value) {
    this.repository.set(this.scope + key, value);
  }

  remove(key) {
    this.repository.delete(this.scope + key);
  }

  clear() {
    this.repository.forEach((key) => {
      if (key.startsWith(this.scope)) {
        this.repository.delete(key);
      }
    });
  }
}

export const createStorage = (repository, scope) =>
  new StorageClass(repository, scope);

export default StorageClass;
